<template>
  <div id="contact">
    <BottomBar />
    <div class="top">
      <h1>
        <i class="anyteachicon anyteach-headset" />
        <span>联系我们</span>
      </h1>
      <h2>AnyTeach 小管家可以解答您的疑问。</h2>
    </div>
    <div class="content">
      <div class="card-wrapper">
        <div class="card">
          <h1>上班时间</h1>
          <h2>{{ hours }}</h2>
        </div>
        <div class="card">
          <h1>电话</h1>
          <a :href="'tel:' + tel">
            <i class="anyteachicon anyteach-phone" />
            {{ tel }}
          </a>
        </div>
        <div class="card">
          <h1>小管家微信</h1>
          <CustomerService />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BottomBar from "../public/footer"
import CustomerService from "../public/CustomerService"
export default {
  name: "Contact",
  components: { BottomBar, CustomerService },
  data() {
    return {
      contact: null,
      isLoading: true,
      tel: "400-0396-999",
      hours: "09:00 — 21:00",
      defaultList: [
        {
          title: "AnyTeach 小管家 2",
          desc: "咨询趣蒙课",
          url: "https://cdn.anyteach.cn/cs-2.jpeg",
        },
        {
          title: "AnyTeach 小管家 1",
          desc: "咨询其他课程",
          url: "https://cdn.anyteach.cn/cs-1.jpg",
        },
      ],
    }
  },
  methods: {
    async getContact() {
      const data = await this.$api.user.CONTACT()
      if (data) {
        this.contact = data
      }
      this.isLoading = false
    },
  },
  created() {
    this.getContact()
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";

#contact {
  background: white;
  @include avenir();
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;

  .top {
    padding: 35px 5% 20px 5%;
    color: $black;
    border-bottom: 1px solid #eee;
    h1 {
      font-size: 1.5625rem;
      @include avenir-demi();
      line-height: 1.3;
      i {
        margin-right: 5px;
      }
    }
    h2 {
      font-size: 1rem;
      font-weight: 400;
    }
  }

  .empty {
    height: 200px;
  }
  .content {
    padding-bottom: 20px;
    .switcher {
      margin-bottom: 20px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      padding: 13px 5%;
      overflow: scroll;
      white-space: nowrap;
      .tab {
        display: inline-block;
        margin: 0 10px 0 0;
        font-weight: 500;
        opacity: 0.5;
        transition: 0.1s;
        font-size: 13px;
      }
      .tab:last-child {
        margin-right: 15px;
      }
      .active {
        color: $blue;
        opacity: 1;
      }
    }
    .card-wrapper {
      padding: 0 5%;
    }
    .card {
      padding: 10px 0 0px 0;
      clear: both;
      h1 {
        font-size: 0.8125rem;
        @include avenir-demi();
        line-height: 1.5;
        margin: 10px 0 5px 0;
      }
      h2,
      a {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1;
        display: block;
      }
      h3 {
        font-size: 0.8125rem;
        font-weight: 400;
        opacity: 0.6;
      }
      h4 {
        font-size: 0.8125rem;
        @include avenir-demi();
      }
      a {
        display: inline-block;
        @include avenir-demi();
        padding: 0 0 3px 0;
        color: $blue;
      }
      .call {
        border: none;
        border-radius: 4px;
        padding: 10px 10px;
        color: $blue;
        display: inline-block;
        font-size: 0.8125rem;
        @include avenir-demi();
        &:active,
        &:hover {
          color: $blue !important;
        }
      }

      .wechat {
        border: 1px solid #eee;
        border-radius: 5px;
        padding: 15px 0;
        text-align: center;
        margin: 5px 0 0 0;
        h2 {
          margin: 5px 0 0 0;
        }
        img {
          width: 100px;
        }
      }
    }
  }
}
</style>
